import React from "react";
import { ConfirmProvider } from "./ConfirmDialog";
import { ToastProvider } from "./Toast";

/** Toasts and confirm dialogs for the whole admin panel. */
const AdminUiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <ToastProvider>
    <ConfirmProvider>{children}</ConfirmProvider>
  </ToastProvider>
);

export default AdminUiProvider;
